<template>
  <question-card @submit="submit" :disabled="buttonDisabled" :buttonText="UIComponentData.Button.Translations[questionnaireLead.Language]">
    <template #title>{{UIComponentData.Header.Translations[questionnaireLead.Language]}}</template>
    <div>
      <v-text-field
        outlined
        v-model="questionnaireLead.FirstName"
        ref="name"
        :label="UIComponentData.InputPlaceholder1.Translations[questionnaireLead.Language]"
        required
        autofocus
      />
    </div>
    <div>
      <v-text-field
        outlined
        :label="UIComponentData.InputPlaceholder2.Translations[questionnaireLead.Language]"
        v-model="questionnaireLead.LastName"
        required
      />
    </div>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import QuestionCard from "@/components/QuestionCard.vue";

export default {
  name: "name-step",
  components: {
    QuestionCard,
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
    buttonDisabled() {
      return (
        !this.questionnaireLead.FirstName || !this.questionnaireLead.LastName
      );
    },
  },
  methods: {
    ...mapActions(["mutateLead"]),
    submit() {
      this.mutateLead(this.questionnaireLead);
      this.$emit('route-to-next-slide',false);
    },
  },
};
</script>
